import { FC, PropsWithChildren, useState } from "react";
import { Icon } from "@components";

interface CardProps {
    title?: string;
    collapsible?: boolean;
    customClassName?: string;
    actions?: JSX.Element;
}

export const Card: FC<
    PropsWithChildren<CardProps>
> = ({ title, children, collapsible, customClassName, actions }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleCollapse = () => {
        if (collapsible) {
            setIsCollapsed((prevState) => !prevState);
        }
    };

    return (
        <div className={`border rounded-lg p-4 shadow-sm bg-white ${customClassName}`}>
            {
                !!title && (
                    <div className="flex justify-between items-center">
                        <h2 className="text-lg font-semibold mb-2 truncate whitespace-nowrap overflow-hidden max-w-[80%]">
                            {title}
                        </h2>
                        {
                            collapsible && (
                                <button
                                    onClick={(e) => {
                                        e.preventDefault()
                                        toggleCollapse()
                                    }}
                                    className="transition-transform duration-200"
                                    style={{
                                        transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
                                    }}
                                >
                                    <Icon iconName="ChevronUp" size={30} />
                                </button>
                            )
                        }
                        {actions}
                    </div>
                )
            }

            {!isCollapsed && children}
        </div>
    );
};
